// Which pages use the fresh app look (readable sans headings, cream canvas). Couples' guest-facing wedding websites keep the theme the couple chose.

const PREFIXES = [
  "/couple", "/pro", "/venue", "/business", "/messages", "/dashboard/inbox", "/feedback",
  "/blog", "/inspiration", "/weddings", "/real-wedding", "/submit-wedding", "/cultural", "/cultural-attire",
  "/directory", "/find-a-wedding-", "/find-suppliers", "/free-tools", "/features", "/tools/", "/open-days",
  "/wedding-fairs", "/best/", "/guide/", "/compare/", "/plan-everything", "/venue-match", "/request-quotes",
  "/help", "/about", "/contact", "/policies", "/demo",
];
// SEO collection pages such as /wedding-venues/:location or /luxury-wedding-photographers/:location.
const COLLECTION = /^\/(?:(?:affordable|luxury|best|budget|top-rated)-)?wedding-[a-z-]+\/[^/]+\/?$/;
// Business dashboards under /supplier (the public profile at /supplier/:id is not one of them).
const SUPPLIER_TOOLS = new Set([
  "onboarding", "dashboard", "profile", "enquiries", "reviews", "events", "roi", "lost-leads", "analytics", "pricing",
  "couples-activity", "grow-business", "competitor-rankings", "improve-profile", "badges", "settings",
  "quote-templates", "pipeline-stages", "referrals", "couples", "team-access", "subscription", "concierge",
]);

export function isFreshScope(pathname: string): boolean {
  const p = pathname.toLowerCase();
  if (p === "/") return true;
  if (p.startsWith("/wedding/") || p.startsWith("/share/")) return false;
  if (p.startsWith("/supplier/")) return SUPPLIER_TOOLS.has(p.split("/")[2] ?? "");
  if (COLLECTION.test(p)) return true;
  return PREFIXES.some((prefix) =>
    /[-/]$/.test(prefix) ? p.startsWith(prefix) : p === prefix || p.startsWith(`${prefix}/`));
}
